import { step1, step2, step4 } from "@/config/constants/steps";

describe("step1", () => {
  it("should have the correct properties", () => {
    expect(step1).toHaveProperty("APROBADO", "paso2");
    expect(step1).toHaveProperty("RECHAZADO_OTROS");
    expect(step1).toHaveProperty("INDIVIDUO_NEGATIVO");
    expect(step1).toHaveProperty("RECHAZADO", "error-3");
    expect(step1).toHaveProperty("ERROR_TECNICO");
  });
});

describe("step2", () => {
  it("should have the correct properties", () => {
    expect(step2).toHaveProperty("APROBADO", "paso3");
    expect(step2).toHaveProperty("EXCEDIDO", "paso4");
    expect(step2).toHaveProperty("ERROR_NOSIS");
    expect(step2).toHaveProperty("RECHAZADO");
    expect(step2).toHaveProperty("ERROR", "error-1");
    expect(step2).toHaveProperty("ERROR_TECNICO");
  });
});

describe("step4", () => {
  it("should have the correct properties", () => {
    expect(step4).toHaveProperty("GRACIAS");
    expect(step4).toHaveProperty("ERROR", "error-1");
    expect(step4).toHaveProperty("ERROR_TECNICO");
  });
});
